import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MAX_CHARACTERS } from '../../constants';
import { IRecipientDetails } from '../../types';

interface RecipientState {
  recipientDetails: IRecipientDetails & {
    errors: { [key: string]: string };
  };
}

const initialState: RecipientState = {
  recipientDetails: {
    firstName: '',
    lastName: '',
    mobile: '',
    confirmMobileNumber: '',
    mobileNumberDisplay: '',
    confirmMobileNumberDisplay: '',
    giftMessage: '',
    giftMessageCharCounter: MAX_CHARACTERS,
    errors: {},
  },
};

const { actions, reducer } = createSlice({
  name: 'RecipientState',
  initialState,
  reducers: {
    setRecipient: (state, action: PayloadAction<RecipientState['recipientDetails']>) => {
      const { payload } = action;
      state.recipientDetails = payload;
    },
    resetRecipient: () => initialState,
  },
});

export const recipientActions = {
  ...actions,
};

export const recipientReducer = reducer;
